import { createSelector } from 'reselect'
import { selectBase } from 'selectors/bootstrap/selectBase'
import { STATES as STORE_STATES } from 'ducks/bootstrap/constants'

export const selectIsGroupsBootstrapped = createSelector(
  selectBase,
  bootstrap => bootstrap.groups === STORE_STATES.LOADED
)
